// // hooks/useFingerprint.js
// import { useEffect, useState } from 'react';
// // eslint-disable-next-line import/no-extraneous-dependencies
// import FingerprintJS from '@fingerprintjs/fingerprintjs';

// function useFingerprint() {
//     const [fingerprint, setFingerprint] = useState(null);

//     useEffect(() => {
//         const loadFingerprint = async () => {
//             try {
//                 const fp = await FingerprintJS.load();
//                 const result = await fp.get();
//                 setFingerprint(result.visitorId);
//             } catch (error) {
//                 console.error('Failed to load fingerprint:', error);
//             }
//         };

//         loadFingerprint();
//     }, []);

//     return fingerprint;
// }

// export default useFingerprint;


// hooks/useFingerprint.js
import { useEffect, useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import FingerprintJS from '@fingerprintjs/fingerprintjs';

function useFingerprint() {
    const [fingerprint, setFingerprint] = useState('');

    useEffect(() => {
        const key = 'fingerprint_id';
        const storedFingerprint = localStorage.getItem(key);

        if (storedFingerprint) {
            setFingerprint(storedFingerprint);
        } else {
            const generateFingerprint = async () => {
                try {
                    const fp = await FingerprintJS.load();
                    const result = await fp.get();
                    const visitorId = result.visitorId;
                    localStorage.setItem(key, visitorId);
                    setFingerprint(visitorId);
                } catch (error) {
                    console.error('Failed to load fingerprint:', error);
                }
            };

            generateFingerprint();
        }
    }, []);

    return fingerprint;
}

export default useFingerprint;